import React, { useState } from "react";
import { Row, Col } from "reactstrap";
import { useSelector } from "react-redux";
//windowsize
import useWindowSize from "../../Component/use-window-size";

const Measures = () => {
  //get current windowsize
  const size = useWindowSize();
  const [cardFocused] = useState(false);

  const totalMeasuredCostsYear1 = useSelector(
    (state) => state.TotalMeasuredCostsYear.year1
  );
  const totalMeasuredCostsYear2 = useSelector(
    (state) => state.TotalMeasuredCostsYear.year2
  );
  const totalMeasuredCostsYear3 = useSelector(
    (state) => state.TotalMeasuredCostsYear.year3
  );
  const activeYear = useSelector((state) => state.year);
  const sizeForMobile = useSelector((state) => state.sizeForMobile.size);


  const card = {
    backgroundColor: cardFocused ? "rgb(255 215 215)" : "rgb(255 242 242)",
    transition: "0.5s",
    width: "100%",
  };

  const outputElement = {
    backgroundColor: cardFocused ? "rgb(255 215 215)" : "rgb(255 242 242)",
    borderColor: cardFocused ? "rgb(255 215 215)" : "rgb(255 242 242)",
    transition: "0.5s",
    color: cardFocused ? "#000000" : "#777",
    cursor: "default",
    overflow: "hidden",
    whiteSpace: "nowrap"
  };

  return (
    <>
      {size.width < sizeForMobile ? (
        <Row className="g-0 mt-2 m-auto rounded-3" style={card}>
          <Col
            xs={23}
            className="p-2 d-flex align-items-center justify-content-center text-center responsive-fontsize"
            style={{
              color: "#777",
              overflow: "hidden",
              whiteSpace: "nowrap",
              cursor: "default",
            }}
          >
            Åtgärdskostnader
          </Col>

          <Col xs={17} className="offset-0 p-2" style={{ padding: "0px" }}>
            <output className="form-control text-center" style={outputElement}>
              -{" "}
              {activeYear.year === "year1"
                ? totalMeasuredCostsYear1 > 0 || totalMeasuredCostsYear1 < 0
                  ? Math.round(totalMeasuredCostsYear1)
                  : 0
                : activeYear.year === "year2"
                ? totalMeasuredCostsYear2 > 0 || totalMeasuredCostsYear2 < 0
                  ? Math.round(totalMeasuredCostsYear2)
                  : 0
                : activeYear.year === "year3"
                ? totalMeasuredCostsYear3 > 0 || totalMeasuredCostsYear3 < 0
                  ? Math.round(totalMeasuredCostsYear3)
                  : 0
                : 0}
            </output>
          </Col>
        </Row>
      ) : (
        <Row className="g-0 mt-2 m-auto rounded-3" style={card}>
          <Col
            xs={17}
            className="p-2 d-flex align-items-center justify-content-center text-center responsive-fontsize"
            style={{
              color: "#777",
              overflow: "hidden",
              whiteSpace: "nowrap",
              cursor: "default",
            }}
          >
            Åtgärdskostnader
          </Col>

          <Col xs={7} className="offset-16 p-2" style={{ padding: "0px" }}>
            <output className="form-control text-center" style={outputElement}>
              -{" "}
              {activeYear.year === "year1"
                ? totalMeasuredCostsYear1 > 0 || totalMeasuredCostsYear1 < 0
                  ? Math.round(totalMeasuredCostsYear1)
                  : 0
                : activeYear.year === "year2"
                ? totalMeasuredCostsYear2 > 0 || totalMeasuredCostsYear2 < 0
                  ? Math.round(totalMeasuredCostsYear2)
                  : 0
                : activeYear.year === "year3"
                ? totalMeasuredCostsYear3 > 0 || totalMeasuredCostsYear3 < 0
                  ? Math.round(totalMeasuredCostsYear3)
                  : 0
                : 0}
            </output>
          </Col>
        </Row>
      )}
    </>
  );
};
export default Measures;
